export default __webpack_public_path__ + "static/media/partner-fcw.e2bbae30.jpg";